module.exports = __webpack_public_path__ + "img/sports.ae4a3d3a.png";